import axios from "axios";
import { navigate } from "gatsby";
import {
  SET_ORDERS,
  SET_ORDER,
  SET_LOADING,
  SET_ERROR,
  SET_BANK_ACCOUNT_ORDERS,
  SET_BANK_ACCOUNT_ORDER,
} from "../constants/support";
import { makeActionCreator } from "../reducers/index";
import {ROOT_API_URL} from "../constants/http";



const setOrders = makeActionCreator(SET_ORDERS);
const setOrder = makeActionCreator(SET_ORDER);
const setLoading = makeActionCreator(SET_LOADING);
const setError = makeActionCreator(SET_ERROR);

const setBankAccountOrders = makeActionCreator(SET_BANK_ACCOUNT_ORDERS);
const setBankAccountOrder = makeActionCreator(SET_BANK_ACCOUNT_ORDER);

export const fetchOrders = (params = null) => async dispatch => {
  try {
    let url = `${ROOT_API_URL}/support/orders`;
    if (params) {
      url += `?${(new URLSearchParams(params))}`
    }

    dispatch(setLoading(true));
    const { data } = await axios.get(url);
    dispatch(setOrders(data));
  } catch (error) {
    dispatch(setError(error));
  }
};

export const fetchOrder = code => async dispatch => {
  try {
    const url = `${ROOT_API_URL}/support/orders/${code}`;
    const { data } = await axios.get(url);
    dispatch(setOrder(data));
  } catch (error) {
    console.log(error);
    if (error.response.status === 404) {
      navigate("/404");
    }
    dispatch(setError(error));
  }
};

export const setFileStatus = (
  code,
  status,
  hash,
  rejectionReason = null
) => async (dispatch, state) => {
  try {
    const url = `${ROOT_API_URL}/files/${code}`;
    const reqBody = { code, status, hash };
    if (rejectionReason) {
      reqBody.rejectionReason = rejectionReason;
    }
    const { data } = await axios.put(url, reqBody);
    if (data.status === "verified") {
      const { orders } = state().support;
      navigate("/support");
      dispatch(setOrders(orders.filter(({ code }) => code !== data.code)));
    } else {
      dispatch(setOrder(data));
    }
  } catch (error) {
    console.error(error);
  }
};

export const setOrderStatus = (
  code,
  status,
  rejectionReason = null
) => async dispatch => {
  try {
    const url = `${ROOT_API_URL}/orders/${code}/status`;
    const reqBody = { status };
    if (rejectionReason) {
      reqBody.rejectionReason = rejectionReason;
    }
    const { data } = await axios.post(url, reqBody);
    dispatch(setOrder(data));
  } catch (error) {
    console.error(error);
  }
};

export const fetchBankAccountOrders = (params = null) => async dispatch => {
  try {
    let url = `${ROOT_API_URL}/support/orders/bank-accounts`;
    if (params) {
      url += `?${(new URLSearchParams(params))}`
    }

    dispatch(setLoading(true));
    const { data } = await axios.get(url);
    dispatch(setBankAccountOrders(data));
  } catch (error) {
    dispatch(setError(error));
  }
};


export const fetchBankAccountOrder = code => async dispatch => {
  try {
    const url = `${ROOT_API_URL}/support/orders/bank-accounts/${code}`;
    const { data } = await axios.get(url);
    dispatch(setBankAccountOrder(data.data));
  } catch (error) {
    console.log(error);
    if (error.response.status === 404) {
      navigate("/404");
    }
    dispatch(setError(error));
  }
};


export const setBankAccountOrderStatus = (code, status) => async dispatch => {
  try {
    const url = `${ROOT_API_URL}/support/orders/bank-accounts/${code}/status`;
    const { data } = await axios.post(url, { status });
    dispatch(setBankAccountOrder(data.data));
  } catch (error) {
    console.log(error);
    if (error.response.status === 404) {
      navigate("/404");
    }
    dispatch(setError(error));
  }
};
